export * from './FourColumnsTable';
